import React, { useState, useEffect } from "react";
import styled from "styled-components";
import GenericModal from "../../../../components/modal/GenericModal";
import parse from "html-react-parser";

const Firma = styled.img`
  max-height: 60px;
  position: relative;
`;

const DivDatoPreview = styled.div`
    //width: ${props => props.width ?? "200px"};;
    position: absolute;
    //display: flex;
    //justify-content: center;
    //align-items: center;
    font-size: 10px;
    top: ${props => props.top ?? ""};
    bottom: ${props => props.bottom ?? ""};
    left: ${props => props.left ?? ""};
    right: ${props => props.right ?? ""};
    margin: 0; 
    padding: 0;
`;

const PreviewFormato = ({ showModal, formValues }) => {

  return (
    <GenericModal
      showModal={showModal}
      titulo={"Preview Formato"}
      width="900px"
    >
        <div style={{display: "inline-block"}}>
            <div  style={{zoom: "60%", "user-select": "none"}}>
                <>
                    {parse(`${formValues?.PapeletaPreview?.replace("","")}`)}
                    {/*<img className="w-100 h-auto" src={formValues?.FormatoImage}/>*/}
                    {/*<DivDatoPreview id="Firma" bottom="45px" left="425px"><Firma src={formValues?.Firma}/></DivDatoPreview>*/}
                    {/*<DivDatoPreview id="ApellidoPaterno" top="118px" left="45px">{formValues?.ApellidoPaterno}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="ApellidoMaterno" top="118px" left="295px">{formValues?.ApellidoMaterno}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="Nombres" width="150px" top="118px" right="317px">{formValues?.Nombres}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="Cargo" top="118px" right="85px">{formValues?.Cargo}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="FechaIngresoEmpresa" top="147px" left="161px">{formValues?.FechaIngresoEmpresa}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="Sede" width="130px" top="147px" left="395px">{formValues?.Sede}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="Codigo" width="80px" top="147px" right="255px">{formValues?.CodigoOfisis}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="NumeroDocumento" width="90px" top="147px" right="77px">{formValues?.NumeroDocumento}</DivDatoPreview>*/}



                    {/*<DivDatoPreview id="EsLicenciaPorHoraLactancia" top="185px" left="270px">{formValues?.EsLicenciaPorHoraLactancia}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="EsLicenciaPorPaternidad" top="215px" left="270px">{formValues?.EsLicenciaPorPaternidad}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="EsLicenciaPorDuelo" top="245px" left="270px">{formValues?.EsLicenciaPorDuelo}</DivDatoPreview>*/}

                    {/*<DivDatoPreview id="EsLicenciaConGoceDeHaber" top="185px" left="395px">{formValues?.EsLicenciaConGoceDeHaber}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="EsLicenciaSinGoceDeHaber" top="215px" left="395px">{formValues?.EsLicenciaSinGoceDeHaber}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="EsLicenciaPorMatrimonio" top="245px" left="395px">{formValues?.EsLicenciaPorMatrimonio}</DivDatoPreview>*/}

                    {/*<DivDatoPreview id="EsOtroTipoLicencia" top="245px" left="503px">{formValues?.EsOtroTipoLicencia}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="NombreOtroTipoLicencia" top="245px" left="608px">{formValues?.NombreOtroTipoLicencia}</DivDatoPreview>*/}

                    {/*<DivDatoPreview id="MotivoSolicitud" top="215px" left="420px">{formValues?.MotivoSolicitud}</DivDatoPreview>*/}


                    {/*<DivDatoPreview id="FechaInicioPapeleta" top="274px" left="298px">{formValues?.FechaInicioPapeleta}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="FechaFinPapeleta" top="274px" left="613px">{formValues?.FechaFinPapeleta}</DivDatoPreview>*/}

                    {/*<DivDatoPreview id="FechaRegistro" width="120px" bottom="65px" left="65px">{formValues?.FechaRegistro}</DivDatoPreview>*/}

                    {/*<DivDatoPreview id="Observaciones" className="justify-content-start" width="840px" top="73%" left="45px"></DivDatoPreview>*/}

                    {/*<DivDatoPreview id="AprobadorPor_Nivel1" className="text-center" width="220px" bottom="70px" left="160px">{formValues?.AprobadorPor_Nivel1}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="FechaAprobacion_Nivel1" bottom="55px" left="220px">{formValues?.FechaAprobacion_Nivel1}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="AprobadorPor_Nivel2" className="text-center" width="220px" bottom="70px" right="250px">{formValues?.AprobadorPor_Nivel2}</DivDatoPreview>*/}
                    {/*<DivDatoPreview id="FechaAprobacion_Nivel2" bottom="55px" right="200px">{formValues?.FechaAprobacion_Nivel2}</DivDatoPreview>*/}
                </>
            </div>
        </div>


    </GenericModal>
  );
};

export default PreviewFormato;
